import { Page } from '@/core/architecture'

import { MyProfileEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * MyProfileEdit Page
 * Implemented as a practical sample.
 */
export const MyProfileEdit: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <MyProfileEditTemplate
      state={state}
      onSubmitMyProfile={actions.onSubmitMyProfile}
      onClickAvatar={actions.onClickAvatar}
    />
  )
}
